import { getPurchaseButtonInfoForEPGTransactions } from 'action-creators/payway/purchaseButtonInfo';
import { showEpgTransactions } from 'containers/Player/actions/epgTransactions/epgTransactions.actions';
import { dispatchWithPromise } from 'utils/redux/dispatchWithPromise';

export const getInfoToShowTransactions = async (
  groupId,
  epgChannels,
  dispatch,
) => {
  const getPurchaseButtonInfoPromise = dispatchWithPromise(
    dispatch,
    getPurchaseButtonInfoForEPGTransactions({ group_id: groupId }),
  );
  const showEpgTransactionsPromise = dispatchWithPromise(
    dispatch,
    showEpgTransactions(
      epgChannels?.find(channel => channel.group_id === groupId)?.group?.common,
    ),
  );
  await Promise.all([getPurchaseButtonInfoPromise, showEpgTransactionsPromise]);
};
